














































// components/admin/AdminDashboard.jsx   (ULTIMATE FINAL VERSION – EVERYTHING YOU WANTED)
import { useState, useEffect } from "react";
import { 
  Users, Building2, Briefcase, UserPlus, Building, CheckCircle, Clock, 
  Menu, X, Send, UserCheck, AlertCircle, Calendar, Mail, Phone, Loader2, ChevronRight, 
  FormInput
} from "lucide-react";
import MarketersList from "./MyMarketerList";
import PendingMarketers from "./PendingMarketers";

export default function AdminDashboard() {
  const [tab, setTab] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [data, setData] = useState({ 
    mySeekers: [], 
    myEmployers: [], 
    allRequests: [] 
  });
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const API = process.env.REACT_APP_API_URL;

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}myadmin/latestdashboard`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });
      const d = await res.json();
      setData(d);
    } catch (err) {
      alert("Failed to load data");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const navItems = [
    { id: "dashboard", name: "Dashboard", icon: <Briefcase className="w-5 h-5" /> },
    { id: "create-seeker", name: "Create Seeker", icon: <UserPlus className="w-5 h-5" /> },
    { id: "create-employer", name: "Create Employer", icon: <Building className="w-5 h-5" /> },
    { id: "request-job", name: "Request Worker", icon: <Send className="w-5 h-5" /> },
    { id: "pending-marketers", name: "Pending Marketers", icon: <Send className="w-5 h-5" /> },
    { id: "assign", name: "Assign Worker", icon: <UserCheck className="w-5 h-5" /> },
    { id: "seekers", name: "My Seekers", icon: <Users className="w-5 h-5" /> },
    { id: "employers", name: "My Employers", icon: <Building2 className="w-5 h-5" /> },
    { id: "marketerForm", name: "create Marketer", icon: <FormInput className="w-5 h-5" /> },
    { id: "marketers", name: "Marketers", icon: <FormInput className="w-5 h-5" /> },
    { id: "history", name: "Full History", icon: <Clock className="w-5 h-5" /> },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Mobile Menu */}
      <button onClick={() => setSidebarOpen(!sidebarOpen)} className="lg:hidden fixed top-4 left-4 z-50 p-3 bg-purple-600 text-white rounded-lg shadow-lg">
        {sidebarOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>

      {/* Sidebar */}
      <div className={`fixed inset-y-0 left-0 z-40 w-64 bg-white shadow-xl transform transition-transform lg:translate-x-0 ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}`}>
        <div className="p-6 border-b">
          <h2 className="text-xl font-bold text-purple-700">JobPlartform Admin</h2>
        </div>
        <nav className="p-4 space-y-1">
          {navItems.map(item => (
            <button key={item.id} onClick={() => { setTab(item.id); setSidebarOpen(false); setSelectedUser(null); }}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-left transition ${tab === item.id ? "bg-purple-600 text-white" : "hover:bg-gray-100"}`}>
              {item.icon}
              <span className="font-medium">{item.name}</span>
            </button>
          ))}
        </nav>
      </div>

      {/* Main Content */}
      <div className="lg:ml-64 p-6 pt-20 lg:pt-8">
        {/* Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
          <div className="bg-white p-6 rounded-lg shadow">
            <Users className="w-10 h-10 text-blue-600 mb-2" />
            <p className="text-2xl font-bold">{data.mySeekers?.length || 0}</p>
            <p className="text-gray-600">Seekers</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow">
            <Building2 className="w-10 h-10 text-green-600 mb-2" />
            <p className="text-2xl font-bold">{data.myEmployers?.length || 0}</p>
            <p className="text-gray-600">Employers</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow">
            <AlertCircle className="w-10 h-10 text-orange-600 mb-2" />
            <p className="text-2xl font-bold">{data.allRequests?.filter(r => r.status === "pending").length || 0}</p>
            <p className="text-gray-600">Pending Jobs</p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          {tab === "dashboard" && <DashboardHome data={data} />}
          {tab === "marketers" && <MarketersList data={data} />}
          {tab === "marketerForm" && <CreateMarketerForm data={data} />}
          {tab === "create-seeker" && <CreateSeekerForm onSuccess={fetchData} />}
          {tab === "create-employer" && <CreateEmployerForm onSuccess={fetchData} />}
          {tab === "pending-marketers" && <PendingMarketers onSuccess={fetchData} />}
          {tab === "request-job" && <RequestWorkerForm employers={data.myEmployers} onSuccess={fetchData} />}
          {tab === "assign" && <AssignWorkerTab requests={data.allRequests?.filter(r => r.status === "pending")} seekers={data.mySeekers} onSuccess={fetchData} />}
          {tab === "seekers" && <MySeekersList seekers={data.mySeekers} requests={data.allRequests} onSelect={setSelectedUser} />}
          {tab === "employers" && <MyEmployersList employers={data.myEmployers} requests={data.allRequests} onSelect={setSelectedUser} />}
          {tab === "history" && <FullHistoryTab requests={data.allRequests} />}
          {selectedUser && <UserDetailModal user={selectedUser} requests={data.allRequests} onClose={() => setSelectedUser(null)} />}
        </div>
      </div>
    </div>
  );
}

/* ALL SECTIONS WITH LOADING SPINNERS + DROPDOWNS + FULL DETAILS */

function RequestWorkerForm({ employers, onSuccess }) {
  const [form, setForm] = useState({
    employerEmail: "", jobPosition: "", salary: "", qualification: "", gender: "any", jobType: "full-time", otherRequirements: ""
  });
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    if (!form.employerEmail || !form.jobPosition || !form.salary) return alert("Fill required fields");
    setSubmitting(true);
    const res = await fetch(`${process.env.REACT_APP_API_URL}admin/request-seeker-on-behalf`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}` },
      body: JSON.stringify(form)
    });
    const d = await res.json();
    alert(d.success ? "Request sent!" : d.message);
    d.success && onSuccess();
    setSubmitting(false);
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Request Worker for Employer</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl">
        <select className="p-3 border rounded-lg" value={form.employerEmail} onChange={e => setForm({...form, employerEmail: e.target.value})}>
          <option value="">Select Employer *</option>
          {employers.map(e => (
            <option key={e._id} value={e.email}>{e.companyName} ({e.email})</option>
          ))}
        </select>
        <input placeholder="Job Position *" className="p-3 border rounded-lg" onChange={e => setForm({...form, jobPosition: e.target.value})} />
        <input placeholder="Salary (e.g. 80000) *" className="p-3 border rounded-lg" onChange={e => setForm({...form, salary: e.target.value})} />
        <input placeholder="Qualification" className="p-3 border rounded-lg" onChange={e => setForm({...form, qualification: e.target.value})} />
        <select className="p-3 border rounded-lg" onChange={e => setForm({...form, gender: e.target.value})}>
          <option value="any">Any Gender</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
        </select>
        <select className="p-3 border rounded-lg" onChange={e => setForm({...form, jobType: e.target.value})}>
          <option value="full-time">Full Time</option>
          <option value="part-time">Part Time</option>
          <option value="contract">Contract</option>
        </select>
        <textarea placeholder="Other Requirements" rows="3" className="p-3 border rounded-lg md:col-span-2" onChange={e => setForm({...form, otherRequirements: e.target.value})} />
      </div>
      <button onClick={submit} disabled={submitting} className="mt-6 bg-orange-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-orange-700 disabled:opacity-70 flex items-center gap-2">
        {submitting ? <><Loader2 className="animate-spin" /> Sending...</> : "Send Request"}
      </button>
    </div>
  );
}

function AssignWorkerTab({ requests, seekers, onSuccess }) {
  const [selectedSeeker, setSelectedSeeker] = useState("");
  const [submitting, setSubmitting] = useState({});

  const assign = async (requestId) => {
    if (!selectedSeeker) return alert("Select a seeker");
    setSubmitting(prev => ({ ...prev, [requestId]: true }));
    const seeker = seekers.find(s => s._id === selectedSeeker);
    const res = await fetch(`${process.env.REACT_APP_API_URL}admin/assign-seeker-by-email/${requestId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}` },
      body: JSON.stringify({ seekerEmail: seeker.email })
    });
    const d = await res.json();
    alert(d.success ? "Assigned!" : d.message);
    d.success && onSuccess();
    setSubmitting(prev => ({ ...prev, [requestId]: false }));
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Assign Worker</h2>
      {requests?.length === 0 ? <p className="text-gray-600">No pending jobs</p> : (
        <div className="space-y-6">
          {requests.map(r => (
            <div key={r._id} className="border p-6 rounded-lg bg-orange-50">
              <p className="font-bold text-xl">{r.jobPosition} - ₦{r.salary}</p>
              <p>Company: {r.employerName}</p>
              <div className="flex gap-3 mt-4">
                <select className="flex-1 p-3 border rounded-lg" value={selectedSeeker} onChange={e => setSelectedSeeker(e.target.value)}>
                  <option value="">Select Job Seeker</option>
                  {seekers.map(s => (
                    <option key={s._id} value={s._id}>{s.firstName} {s.lastName} ({s.email})</option>
                  ))}
                </select>
                <button onClick={() => assign(r._id)} disabled={submitting[r._id]} className="bg-green-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-700 disabled:opacity-70 flex items-center gap-2">
                  {submitting[r._id] ? <><Loader2 className="animate-spin" /> Assigning...</> : "Assign"}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function MySeekersList({ seekers, requests, onSelect }) {
  const getSeekerStats = (seekerId) => {
    const assigned = requests.filter(r => r.assignedSeeker?.toString() === seekerId);
    return { totalAssigned: assigned.length, accepted: assigned.filter(r => r.status === "accepted").length };
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">My Job Seekers ({seekers.length})</h2>
      <div className="space-y-4">
        {seekers.map(s => {
          const stats = getSeekerStats(s._id);
          return (
            <div key={s._id} onClick={() => onSelect({ ...s, type: "seeker", stats })} className="border p-6 rounded-lg hover:bg-gray-50 cursor-pointer flex justify-between items-center">
              <div>
                <p className="font-bold text-lg">{s.firstName} {s.lastName}</p>
                <p className="text-sm text-gray-600">{s.email} • {s.phoneNumber}</p>
                <p className="text-sm">Assigned: {stats.totalAssigned} | Accepted: {stats.accepted}</p>
              </div>
              <ChevronRight className="w-6 h-6 text-gray-400" />
            </div>
          );
        })}
      </div>
    </div>
  );
}

function MyEmployersList({ employers, requests, onSelect }) {
  const getEmployerRequests = (employerId) => {
    return requests.filter(r => r.employer?.toString() === employerId).length;
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">My Employers ({employers.length})</h2>
      <div className="space-y-4">
        {employers.map(e => (
          <div key={e._id} onClick={() => onSelect({ ...e, type: "employer", requestCount: getEmployerRequests(e._id) })} className="border p-6 rounded-lg hover:bg-gray-50 cursor-pointer flex justify-between items-center">
            <div>
              <p className="font-bold text-lg">{e.companyName}</p>
              <p className="text-sm text-gray-600">{e.email} • {e.phoneNumber}</p>
              <p className="text-sm">Total Requests: {getEmployerRequests(e._id)}</p>
            </div>
            <ChevronRight className="w-6 h-6 text-gray-400" />
          </div>
        ))}
      </div>
    </div>
  );
}

function UserDetailModal({ user, requests, onClose }) {
  const userRequests = user.type === "seeker" 
    ? requests.filter(r => r.assignedSeeker?.toString() === user._id)
    : requests.filter(r => r.employer?.toString() === user._id);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-screen overflow-y-auto p-8">
        <div className="flex justify-between items-start mb-6">
          <div>
            <h2 className="text-3xl font-bold">{user.type === "seeker" ? `${user.firstName} ${user.lastName}` : user.companyName}</h2>
            <p className="text-gray-600">{user.email}</p>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg"><X className="w-6 h-6" /></button>
        </div>
        {user.type === "seeker" && (
          <div className="grid grid-cols-2 gap-6 mb-8">
            <div className="bg-blue-50 p-6 rounded-lg"><p className="text-4xl font-bold">{user.stats.totalAssigned}</p><p>Total Assigned</p></div>
            <div className="bg-green-50 p-6 rounded-lg"><p className="text-4xl font-bold">{user.stats.accepted}</p><p>Accepted</p></div>
          </div>
        )}
        {user.type === "employer" && (
          <div className="bg-orange-50 p-6 rounded-lg mb-8">
            <p className="text-4xl font-bold">{user.requestCount}</p>
            <p>Total Job Requests Made</p>
          </div>
        )}
        <h3 className="text-xl font-bold mb-4">History</h3>
        {userRequests.map(r => (
          <div key={r._id} className="border p-4 rounded-lg mb-4">
            <p className="font-semibold">{r.jobPosition}</p>
            <p>Status: <span className={`font-bold ${r.status === "accepted" ? "text-green-600" : r.status === "rejected" ? "text-red-600" : "text-orange-600"}`}>{r.status}</span></p>
            {r.rejectionReason && <p className="text-red-600">Reason: {r.rejectionReason}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}


function DashboardHome({ data }) {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Welcome back, Admin!</h2>
      <p className="text-gray-600 mb-8">Here's your overview for today.</p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        <div className="bg-blue-50 p-6 rounded-lg">
          <p className="text-3xl font-bold text-blue-700">{data.mySeekers?.length || 0}</p>
          <p className="text-gray-700 mt-2">Job Seekers Created</p>
        </div>
        <div className="bg-green-50 p-6 rounded-lg">
          <p className="text-3xl font-bold text-green-700">{data.myEmployers?.length || 0}</p>
          <p className="text-gray-700 mt-2">Employers Created</p>
        </div>
        <div className="bg-orange-50 p-6 rounded-lg">
          <p className="text-3xl font-bold text-orange-700">{data.allRequests?.filter(r => r.status === "pending").length || 0}</p>
          <p className="text-gray-700 mt-2">Pending Assignments</p>
        </div>
      </div>
    </div>
  );
}

function CreateSeekerForm({ onSuccess }) {
  const [form, setForm] = useState({
    firstName: "", lastName: "", email: "", phoneNumber: "", gender: "male",
    address: "", state: "", localGovernment: "", country: "Nigeria"
  });

  const submit = async () => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}admin/create-seeker`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}` },
      body: JSON.stringify({ ...form, password: "12345678" })
    });
    const d = await res.json();
    alert(d.success ? "Seeker created successfully!" : d.message);
    d.success && onSuccess();
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Create New Job Seeker</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl">
        <input placeholder="First Name *" className="p-3 border rounded-lg" onChange={e => setForm({...form, firstName: e.target.value})} />
        <input placeholder="Last Name *" className="p-3 border rounded-lg" onChange={e => setForm({...form, lastName: e.target.value})} />
        <input placeholder="Email *" type="email" className="p-3 border rounded-lg" onChange={e => setForm({...form, email: e.target.value})} />
        <input placeholder="Phone Number *" className="p-3 border rounded-lg" onChange={e => setForm({...form, phoneNumber: e.target.value})} />
        <input placeholder="Address *" className="p-3 border rounded-lg" onChange={e => setForm({...form, address: e.target.value})} />
        <input placeholder="State *" className="p-3 border rounded-lg" onChange={e => setForm({...form, state: e.target.value})} />
        <input placeholder="Local Government *" className="p-3 border rounded-lg" onChange={e => setForm({...form, localGovernment: e.target.value})} />
        <select className="p-3 border rounded-lg" onChange={e => setForm({...form, gender: e.target.value})}>
          <option value="male">Male</option>
          <option value="female">Female</option>
        </select>
      </div>
      <button onClick={submit} className="mt-6 bg-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-700">
        Create Seeker
      </button>
    </div>
  );
}

function CreateEmployerForm({ onSuccess }) {
  const [form, setForm] = useState({
    companyName: "", email: "", phoneNumber: "", address: "", state: "", localGovernment: "", size: "", employerType: ""
  });

  const submit = async () => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}admin/create-employer`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}` },
      body: JSON.stringify({ ...form, password: "12345678" })
    });
    const d = await res.json();
    alert(d.success ? "Employer created!" : d.message);
    d.success && onSuccess();
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Create New Employer</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl">
        <input placeholder="Company Name *" className="p-3 border rounded-lg" onChange={e => setForm({...form, companyName: e.target.value})} />
        <input placeholder="Email *" type="email" className="p-3 border rounded-lg" onChange={e => setForm({...form, email: e.target.value})} />
        <input placeholder="Phone Number *" className="p-3 border rounded-lg" onChange={e => setForm({...form, phoneNumber: e.target.value})} />
        <input placeholder="Address *" className="p-3 border rounded-lg" onChange={e => setForm({...form, address: e.target.value})} />
        <input placeholder="State *" className="p-3 border rounded-lg" onChange={e => setForm({...form, state: e.target.value})} />
        <input placeholder="Local Government *" className="p-3 border rounded-lg" onChange={e => setForm({...form, localGovernment: e.target.value})} />
        <input placeholder="Company Size" className="p-3 border rounded-lg" onChange={e => setForm({...form, size: e.target.value})} />
        <input placeholder="Employer Type" className="p-3 border rounded-lg" onChange={e => setForm({...form, employerType: e.target.value})} />
      </div>
      <button onClick={submit} className="mt-6 bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700">
        Create Employer
      </button>
    </div>
  );
}


function FullHistoryTab({ requests, seekers, employers }) {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Full Assignment History</h2>
      {requests?.length === 0 ? <p>No history yet</p> : (
        <div className="space-y-6">
          {requests.map(r => (
            <div key={r._id} className={`p-6 rounded-lg border ${r.status === "accepted" ? "bg-green-50 border-green-300" : r.status === "rejected" ? "bg-red-50 border-red-300" : "bg-gray-50 border-gray-300"}`}>
              <div className="flex justify-between">
                <div>
                  <p className="font-bold text-lg">{r.jobPosition} → {r.assignedSeekerName || "Not assigned"}</p>
                  <p>Company: {r.employerName}</p>
                  <p className="text-sm text-gray-600">Requested: {new Date(r.createdAt).toLocaleDateString()}</p>
                </div>
                <div className="text-right">
                  <span className={`px-4 py-2 rounded-full text-sm font-bold ${r.status === "pending" ? "bg-orange-500 text-white" : r.status === "assigned" ? "bg-blue-500 text-white" : r.status === "accepted" ? "bg-green-600 text-white" : "bg-red-600 text-white"}`}>
                    {r.status.toUpperCase()}
                  </span>
                  {r.rejectionReason && <p className="text-red-600 mt-2">Reason: {r.rejectionReason}</p>}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}


// In Admin Dashboard → Add this tab
function CreateMarketerForm({ onSuccess }) {
  const [form, setForm] = useState({ name: "", email: "", password: "marketer123", state: "", lga: "" });
  const [loading, setLoading] = useState(false);

  const create = async () => {
    setLoading(true);
    const res = await fetch(`${process.env.REACT_APP_API_URL}admin/create-marketer`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}` },
      body: JSON.stringify(form)
    });
    const d = await res.json();
    alert(d.success ? `Marketer ${form.name} created!\nPassword: marketer123` : d.message);
    d.success && onSuccess();
    setLoading(false);
  };

  return (
    <div className="bg-white p-8 rounded-xl shadow-lg max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold mb-6">Create New Marketer</h2>
      <div className="grid md:grid-cols- b 2 gap-4">
        <input placeholder="Full Name" className="p-3 border rounded-lg" onChange={e => setForm({...form, name: e.target.value})} />
        <input placeholder="Email" type="email" className="p-3 border rounded-lg" onChange={e => setForm({...form, email: e.target.value})} />
        <input placeholder="State" className="p-3 border rounded-lg" onChange={e => setForm({...form, state: e.target.value})} />
        <input placeholder="LGA" className="p-3 border rounded-lg" onChange={e => setForm({...form, lga: e.target.value})} />
      </div>
      <button onClick={create} disabled={loading} className="mt-6 bg-indigo-600 text-white px-813 py-3 rounded-lg font-bold hover:bg-indigo-700">
        {loading ? "Creating..." : "Create Marketer Account"}
      </button>
    </div>
  );
}


/* Keep all other sections (DashboardHome, CreateSeekerForm, etc.) exactly as before */